<template>
  <layout title="About Us" :transparent="true" class="overflow-x-hidden">
    <highlightSection
      backgroundImage="/storage/images/company/youverse_careers.jpg"
      altImage="Company image"
      title="Seamless, secure, private.<br> The future of identity."
      subtitle="Youverse wants to free humankind from bureaucracy while empowering them to own their data. This means safeguarding their right to privacy and streamlining their interactions with businesses."
      leftButton="Contact us"
      urlLeftButton="company#contactus"
      :leftButtonTargetBlank="false"
    />

    <div
      class="w-full mx-auto px-6 sm:px-7 md:px-4 lg:px-10 xl:px-16 max-w-screen-sm md:max-w-screen-xl py-16"
    >
      <h2
        class="text-3xl font-bold text-center mb-12 text-gray-900 px-4 sm:px-6 md:px-8 lg:px-32"
      >
        Born for efficiency, build for privacy
      </h2>
      <rowCardsSection :elements="rowCardsSection" />
    </div>
    <journeyTimeline />
    <founderSection />

    <div
      class="mt-10 flex md:flex-row flex-col items-center w-full mx-auto px-6 sm:px-7 md:px-4 lg:px-10 xl:px-16 max-w-screen-sm md:max-w-screen-xl md:py-16 gap-16"
    >
      <div
        class="flex justify-center flex-col md:max-w-full max-w-md md:text-left text-center"
      >
        <h3 class="text-3xl font-bold">Stay in the loop</h3>
        <p class="mt-6">
          Be the first to know and seize the chance to join our groundbreaking
          team shaping the future!
        </p>
      </div>
      <rowCardsSection :elements="elementJoin" :hoverAnimation="false" imageStyle="" />
    </div>

    <contactus :errors="errors" />
  </layout>
</template>



<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");

const highlightSection = () =>
  import(
    /* webpackChunkName: "highlightSection" */ "./../Components/Layout/highlightSection.vue"
  );
const rowCardsSection = () =>
  import(
    /* webpackChunkName: "rowCardsSection" */ "./../Components/Layout/rowCardsSection.vue"
  );

const contactus = () =>
  import(
    /* webpackChunkName: "contactus" */ "../Components/Layout/CompanyPage/contactus.vue"
  );

const founderSection = () =>
  import(
    /* webpackChunkName: "contactus" */ "../Components/Layout/CompanyPage/founderSection.vue"
  );

const journeyTimeline = () =>
  import(
    /* webpackChunkName: "contactus" */ "../Components/Layout/CompanyPage/journeyTimeline.vue"
  );
export default {
  components: {
    layout,
    highlightSection,
    rowCardsSection,
    contactus,
    founderSection,
    journeyTimeline,
  },
  props: {
    errors: Object,
  },
  data() {
    return {
      rowCardsSection: [
        {
          title: `We feel`,
          text: `At Youverse, we feel the weight of traditional authentication and identity verification processes: burdensome paperwork and hackers’ honeypots.`,
          imageSrc: `/storage/images/icons/user-heart.svg`,
          imageAlt: `We feel`,
          imageStyle: `w-14 h-14`,
        },
        {
          title: `We see`,
          text: `We see the need to change processes to be more efficient and secure, so we’re working with banks, fintechs, hotels, and gaming operators to help them.`,
          imageSrc: `/storage/images/icons/compliance.svg`,
          imageAlt: `We see`,
          imageStyle: `w-14 h-14`,
        },
        {
          title: `We act`,
          text: `We deliver advanced authentication and ID verification solutions to simplify workflows, eliminate bottlenecks, and protect businesses and individuals from fraud.`,
          imageSrc: `/storage/images/icons/users.svg`,
          imageAlt: `We act`,
          imageStyle: `w-14 h-14`,
        },
      ],
      elementJoin: [
        {
          title: `Press`,
          text: `Stay updated with our latest news, achievements, and media highlights.`,
          seeMoreUrl: `/resources/press`,
          imageSrc: `/storage/images/icons/message.svg`,
          imageAlt: `Press`,
          imageStyle: `w-14 h-14`,
        },
        {
          title: `Careers`,
          text: `Bring your talent and passion, and we’ll fuel your growth with innovation and flexibility.`,
          seeMoreUrl: `careers`,
          imageSrc: `/storage/images/icons/user-search.svg`,
          imageAlt: `Careers`,
          imageStyle: `w-14 h-14`,
        },
      ],
    };
  },
};
</script>
